// extracted by mini-css-extract-plugin
export default {"HomeScreen":"HomeScreen_HomeScreen__256u4","HomeScreen__logo":"HomeScreen_HomeScreen__logo__5wG0W","HomeScreen__button-wrapper":"HomeScreen_HomeScreen__button-wrapper__KKWrF"};